import { Component } from "react";

export default class TelescopeView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClicked: false,
      isMessageRead: false,
    };
  }

  componentDidMount() {
    if (typeof localStorage.arSolarSystem !== "undefined") {
      const arSolarSystem = JSON.parse(localStorage.arSolarSystem);

      this.setState({
        isClicked:
          typeof arSolarSystem.isClicked === "undefined"
            ? false
            : arSolarSystem.isClicked,
        isMessageRead:
          typeof arSolarSystem.isMessageRead === "undefined"
            ? false
            : arSolarSystem.isMessageRead,
      });
    }
  }

  downloadMarker() {
    this.setState(
      {
        isClicked: true,
        isMessageRead: true,
      },
      () => {
        localStorage.setItem(
          "arSolarSystem",
          JSON.stringify({
            isClicked: true,
            isMessageRead: true,
          })
        );

        window.open("/assets/solar-system-markers.pdf", "_blank").focus();
      }
    );
  }

  onClickCloseButton() {
    this.setState(
      {
        isMessageRead: true,
      },
      () => {
        localStorage.setItem(
          "arSolarSystem",
          JSON.stringify({
            isMessageRead: true,
          })
        );
      }
    );
  }

  render() {
    const { isClicked, isMessageRead } = this.state;

    return (
      <div className="telescope">
        <div className={`telescope__message ${isMessageRead && "-isRead"}`}>
          <div className="telescope__wrap">
            <svg viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M3.88,13.46L2.46,14.88L4.59,17L2.46,19.12L3.88,20.54L6,18.41L8.12,20.54L9.54,19.12L7.41,17L9.54,14.88L8.12,13.46L6,15.59L3.88,13.46M14,15H20V19H14V15Z"
              />
            </svg>

            <h2>Oh snap! We hit a snag!</h2>

            <p>
              It is unfortunate that your device does not support markerless
              augmented reality. Of course, we do not want you to miss the fun.
              Tap on the button below to download a PDF file of markers, print
              them out and point the web app to the markers to see the planets.
            </p>

            <p>
              <strong>Happy scanning!</strong>
            </p>
          </div>

          <button
            type="button"
            className="info__btn -close"
            onClick={() => {
              this.onClickCloseButton();
            }}>
            <span className="sr-only">Close message</span>
            <svg viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              />
            </svg>
          </button>
        </div>

        <div className="telescope__container">
          <button
            type="button"
            className={`telescope__btn ${isClicked && "-active"}`}
            onClick={() => {
              this.downloadMarker();
            }}>
            <svg viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M14,2H6C4.89,2 4,2.89 4,4V20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20V8L14,2M12,19L8,15H10.5V12H13.5V15H16L12,19M13,9V3.5L18.5,9H13Z"
              />
            </svg>

            <span>Download markers</span>
          </button>

          <iframe
            src="/iframe/index.html"
            title="Through the telescopic view of iframes"
          />
        </div>
      </div>
    );
  }
}
